import {createApp} from "vue";
import AppTrendBooks from "./AppTrendBooks.vue";

createApp(AppTrendBooks).mount("#js-app-trend-books");
